import CheckCircle from "@mui/icons-material/CheckCircle";
import Pending from "@mui/icons-material/Pending";
import { Box, styled, Tooltip } from "@mui/material";
import { Checklist } from "models/Checklist";

type ChecklistStatusIndicatorsProps = { checklist: Checklist };

const renderStatusIcon = (status: boolean) =>
  status ? <CheckCircle color="success" /> : <Pending color="disabled" />;

const StyledBox = styled(Box)({
  display: "grid",
  gridAutoFlow: "column",
  gap: "8px",
});

const ChecklistStatusIndicators: React.FC<ChecklistStatusIndicatorsProps> = (props) => {
  const { checklist } = props;

  return (
    <StyledBox>
      <Tooltip arrow title="Dokumentation">
        {renderStatusIcon(checklist.documentationDone)}
      </Tooltip>
      <Tooltip arrow title="Funktionskontroll">
        {renderStatusIcon(checklist.functionCheck)}
      </Tooltip>
      <Tooltip arrow title="Besiktning">
        {renderStatusIcon(checklist.approved)}
      </Tooltip>
    </StyledBox>
  );
};

export default ChecklistStatusIndicators;
